/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_History_CommitInputs */

const cs_ebr_history_commit = /** @type {(inputs: Ebr_History_CommitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import`)
};

const en_ebr_history_commit = /** @type {(inputs: Ebr_History_CommitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import`)
};

/**
* | output |
* | --- |
* | "Import" |
*
* @param {Ebr_History_CommitInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_history_commit = /** @type {((inputs?: Ebr_History_CommitInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_History_CommitInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_history_commit(inputs)
	return cs_ebr_history_commit(inputs)
});